import { useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

import Header from './Header'
import Knoppie from './Knoppie'


const Stock = () =>{

    const auth = useAuth();
     const location = useLocation();
      const from = location.state?.from || "./";
      console.log("from = "+from)
        const username = auth.auth.user.username
        const access = auth.auth.user.userRole

    return (
        <>
        <Header 
        username={username} 
        role={access}
        destination={from}
        ></Header>
        <div> Stock Index</div>
        
        
       
        <Knoppie
        clickable={true}
        text={"Stock List"}
        destination={"../StockitemsList"}
        from={'./StockControl'}
        
        />
        <Knoppie
        clickable={true}
        text={"Warehouses"}
        destination={"../WarehouseList"}
        from={"./StockControl"}
        
        />
    
    
        <Knoppie
        clickable={true}
        text={"Transactions"}
        destination={"../TransactionList"}
        from={"../StockControl"}
        >

        </Knoppie>
        <Knoppie
        clickable={true}
        text={"Adjustments"}
        destination={""}
        >

        </Knoppie>


        </>
    )

}

export default Stock